// @ts-strict-ignore
import {RESERVED_PROPS_TO_DISPLAY_NAME, ResourceType} from 'common/report/constants';
import {PropertySectionItem} from 'common/query-builder/query-block/properties-menu/item-menu-types';
import {PropertyType} from 'common/report/constants';

export function asPropertyItem(value: string, ptype: PropertyType): PropertySectionItem {
  return {
    value,
    resourceType: ResourceType.User,
    label: RESERVED_PROPS_TO_DISPLAY_NAME[value] || value,
    type: ptype,
    propertyDefaultType: ptype,
  };
}
